export default {
    state: {
        showMergeOption: false
    },
    mutations: {
        SET_SHOW_MERGE_OPTION_STATE (state, payload) {
            state.showMergeOption = payload;
        }
    },
    actions: {
        TOGGLE_MERGE_OPTION (context, payload) {
            context.commit("SET_SHOW_MERGE_OPTION_STATE", !context.state.showMergeOption);
        }
    },
    getters: {
        showMergeOption: state => state.showMergeOption
    },
};
